<nav class="z-navbar w-100 back-cd900">
    <div class="container-default d-flex flex-row justify-space-between items-center p-4">
        <a routerLink="/" class="txt-deco-none" aria-label="Redirection vers la page d’accueil">
            <img src="../../../../assets/logo/logo-540px.webp" width="120px" alt="Manava Immobilier, accueil" />
        </a>
        <button class="nav-toggle txt-cd100" aria-label="Ouvrir/fermer le menu" [attr.aria-expanded]="menuOpen" [class.is-open]="menuOpen" (click)="toggleMenu()">
            <span class="burger" aria-hidden="true">
                <span class="bar bar1"><span class="bar-rot"></span></span>
                <span class="bar bar2"><span class="bar-rot"></span></span>
            </span>
        </button>
        <ul class="reset-list nav-list back-cd900" [class.open]="menuOpen">
            <li class="txt-cd300 mx-2 c-pointer">
                <a [routerLink]="'/'" class="h-100 w-100 txt-cd300 txt-deco-none p-2" routerLinkActive="txt-cd100 txt-w-bold" [routerLinkActiveOptions]="{ exact: true }">Accueil</a>
            </li>
            <li class="txt-cd300 mx-2 c-pointer">
                <a [routerLink]="'/properties'" class="h-100 w-100 txt-cd300 txt-deco-none p-2" routerLinkActive="txt-cd100 txt-w-bold" [routerLinkActiveOptions]="{ exact: true }">Bien immobilier</a>
            </li>
            <li class="txt-cd300 mx-2 c-pointer">
                <a [routerLink]="'/services'" class="h-100 w-100 txt-cd300 txt-deco-none p-2" routerLinkActive="txt-cd100 txt-w-bold" [routerLinkActiveOptions]="{ exact: true }">Services</a>
            </li>
            <li class="txt-cd300 mx-2 c-pointer">
                <a [routerLink]="'/contact'" class="h-100 w-100 txt-cd300 txt-deco-none p-2" routerLinkActive="txt-cd100 txt-w-bold" [routerLinkActiveOptions]="{ exact: true }">Contact</a>
            </li>
        </ul>
    </div>
</nav>
